export const ONBOARDING_TOUR_STORAGE_KEY = 'insider-performance-onboarding-tour-active';

export const isOnboardingTourActive = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(ONBOARDING_TOUR_STORAGE_KEY) === 'true';
};

export const startOnboardingTour = (): void => {
  window.localStorage.setItem(ONBOARDING_TOUR_STORAGE_KEY, 'true');
};

export const stopOnboardingTour = (): void => {
  window.localStorage.removeItem(ONBOARDING_TOUR_STORAGE_KEY);
};
